import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

/* X Icon */
const ArrowLeft = (props) => (<SvgIcon {...props}>
    <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/>
    <path d="M0-.5h24v24H0z" fill="none"/>
  </SvgIcon>
);

export default ArrowLeft;



// WEBPACK FOOTER //
// ./src/icons/ArrowLeft.jsx